import { render } from "./GrantLoginPermissionsPage.vue?vue&type=template&id=0d5560ac&scoped=true&ts=true"
import script from "./GrantLoginPermissionsPage.vue?vue&type=script&lang=ts"
export * from "./GrantLoginPermissionsPage.vue?vue&type=script&lang=ts"

import "./GrantLoginPermissionsPage.vue?vue&type=style&index=0&id=0d5560ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5560ac"]])

export default __exports__